import { CoverWidgetConfig, ITheme } from "@commons-monorepo/types";
import { createContext } from "react";

export const ContentCoverContext = createContext<{
  config: CoverWidgetConfig;
  theme: ITheme;
  storeMetadata: any;
  setStoreInformationInView: (value: boolean) => void;
  isMobile: boolean;
  hasOffers: boolean;
  hasWholesale: boolean;
  stepToPause?: number;
}>({
  config: {} as CoverWidgetConfig,
  theme: {} as ITheme,
  storeMetadata: {},
  isMobile: false,
  setStoreInformationInView: () => {},
  hasOffers: false,
  hasWholesale: false,
  stepToPause: 0,
});
